export type BidderExistsSlice = {
    email: string;
};

export const defaultBidderExistsSlice: BidderExistsSlice = {
    email: '',
};
